/**
 * Logikk for Organizational Health Score (OHS)
 * Implementerer veid gjennomsnittsberegning og helsekategorisering.
 */

export const HEALTH_LEVELS = {
  CRITICAL: { min: 0, max: 39, label: 'Critical organizational health', color: 'rose', desc: 'Organisasjonen har betydelige strukturelle, kulturelle eller ledelsesrelaterte risikoer.' },
  WEAK: { min: 40, max: 59, label: 'Weak organizational health', color: 'orange', desc: 'Organisasjonen fungerer, men har klare risikoområder knyttet til ledelse og stress.' },
  MODERATE: { min: 60, max: 74, label: 'Moderate organizational health', color: 'amber', desc: 'Organisasjonen er stabil, men bør forbedre utvalgte områder for å redusere fremtidig risiko.' },
  STRONG: { min: 75, max: 89, label: 'Strong organizational health', color: 'emerald', desc: 'Organisasjonen viser sunne strukturer og positive kulturelle mønstre.' },
  EXCELLENT: { min: 90, max: 100, label: 'Excellent organizational health', color: 'cyan', desc: 'Høy tillit, sterk ledelse og bærekraftig arbeidsmiljøpraksis.' }
};

export const OHS_DIMENSIONS = [
  { id: 'leadership', name: 'Leadership Quality', weight: 0.12, icon: 'Award', color: 'indigo' },
  { id: 'safety', name: 'Psychological Safety', weight: 0.12, icon: 'Shield', color: 'emerald' },
  { id: 'collaboration', name: 'Collaboration Quality', weight: 0.10, icon: 'Users', color: 'blue' },
  { id: 'culture', name: 'Culture Score', weight: 0.10, icon: 'Globe', color: 'violet' },
  { id: 'conflict', name: 'Conflict Climate', weight: 0.08, icon: 'AlertTriangle', color: 'rose' },
  { id: 'stress', name: 'Stress Level', weight: 0.08, icon: 'Wind', color: 'orange' },
  { id: 'role', name: 'Role Clarity', weight: 0.08, icon: 'Target', color: 'cyan' },
  { id: 'comm', name: 'Communication Quality', weight: 0.08, icon: 'MessageCircle', color: 'indigo' },
  { id: 'trust', name: 'Trust Level', weight: 0.08, icon: 'Heart', color: 'rose' },
  { id: 'engagement', name: 'Employee Engagement', weight: 0.08, icon: 'Zap', color: 'amber' },
  { id: 'we', name: 'Work Environment Score', weight: 0.08, icon: 'Activity', color: 'emerald' },
  { id: 'change', name: 'Change Readiness', weight: 0.08, icon: 'TrendingUp', color: 'fuchsia' }
];

export const getHealthCategory = (score) => {
  if (score >= 90) return HEALTH_LEVELS.EXCELLENT;
  if (score >= 75) return HEALTH_LEVELS.STRONG;
  if (score >= 60) return HEALTH_LEVELS.MODERATE;
  if (score >= 40) return HEALTH_LEVELS.WEAK;
  return HEALTH_LEVELS.CRITICAL;
};

export const calculateOHS = (scores) => {
  let weightedTotal = 0;
  OHS_DIMENSIONS.forEach(dim => {
    weightedTotal += (scores[dim.id] || 0) * dim.weight;
  });
  return Math.round(weightedTotal);
};

export const checkAlertRules = (currentScore, previousScore, metrics) => {
  const alerts = [];
  
  // 1. Drop more than 8 points
  if (previousScore - currentScore > 8) {
    alerts.push({
      id: 'drop-alert',
      type: 'Executive Alert',
      title: 'Signifikant Fall i Helse',
      desc: `OHS-score har falt med ${previousScore - currentScore} poeng dette kvartalet.`,
      severity: 'Critical'
    });
  }

  // 2. Stress up + Trust down
  if (metrics.stress > 70 && metrics.trust < 50) {
    alerts.push({
      id: 'culture-risk',
      type: 'Culture Risk Alert',
      title: 'Erosjon av Tillit',
      desc: 'Økende stress kombinert med fallende tillit indikerer en begynnende ukultur.',
      severity: 'High'
    });
  }

  return alerts;
};

export const mockDeptHealth = [
  { name: 'Administrasjon', score: 88, status: 'Strong' },
  { name: 'Support', score: 72, status: 'Moderate' },
  { name: 'Salg', score: 54, status: 'Weak' },
  { name: 'Utvikling', score: 38, status: 'Critical' }
];

export const mockHistory = [
  { date: 'Q3-23', score: 68 },
  { date: 'Q4-23', score: 65 },
  { date: 'Q1-24', score: 59 },
  { date: 'Q2-24', score: 54 }
];